module.exports = __webpack_public_path__ + "static/media/marker.8f76161c.svg";